<!--导入结算账号-->
<template>
    <div class="content-panel">
        <el-row :gutter="10"  class="ctrl-wrap">
            <el-col :sm="24" :md="12">
                <el-button size="mini"
                    @click="doSelectFile()" type="success"
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="iconfont icon-xuanzewenjian"
                            style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('上传文件')}}</span>
                        </transition>
                </el-button>

                <div ref="fileArea" style="display:none;">
                </div>
            </el-col>
            <el-col :sm="24" :md="12">
                <el-button size="mini"
                    @click="doDownloadTpl()" type="primary"
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('下载模板')}}</span>
                        </transition>
                </el-button>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-table :data="results" :height="docHeight" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="username" :label="msg('账号')" min-width="120" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="fullname" :label="msg('姓名')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="settlerUsername" :label="msg('结算账号')" min-width="120" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="msg" :label="msg('上传结果')" min-width="200" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import XLSX from "xlsx";
export default {
    name: 'UserImportSettleAccount',
    components: {},
    data(){
        return {
            excelHeads: [], //从excel解析出数据的表头
            excelData: null, //从excel解析出的数据
            results:[],
        }
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    mounted(){
    },
    methods:{
        doSelectFile(){  //点击选择文件
            this.$refs.fileArea.innerHTML = "";
            var input = document.createElement("input");
            input.type="file";
            var _this = this;
            input.onchange=this.getUploadFile;
            this.$refs.fileArea.appendChild(input);
            input.click();
        },
        getUploadFile(e) {  //解析上传的excel
            let that = this;

            this.excelData = null
            //拿到所导入文件的名字
            let fileName = e.target.files[0];
            //定义reader，存放文件读取方法
            let reader = new FileReader();
            //启动函数
            reader.readAsBinaryString(fileName)
            //onload在文件被读取时自动触发
            reader.onload = (e) => {
                //workbook存放excel的所有基本信息
                let workbook = XLSX.read(e.target.result, {type: 'binary'})
                //定义sheetList中存放excel表格的sheet表，就是最下方的tab
                let sheetList = workbook.SheetNames
                //存放json数组格式的表格数据
                let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let json = XLSX.utils.sheet_to_json(worksheet, {header:1})

                var heads = json[0];
                that.excelData = json.splice(1);
                that.excelHeads = heads;
                that.$refs.fileArea.innerHTML = "";
                this.doUpload();
            };
        },
        doDownloadTpl(){  //下载一个excel模板，

            var titles = [['账号','姓名','结算账号'],[],[],[],['说明：通过账号匹配用户，更新结算账号字段，姓名可填可不填']];

            var filename = '导入结算账号模板.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
        doUpload(){
            if(!this.excelData || this.excelData.length === 0){
                this.$message(this.msg('请先选择需要导入的文件'));
                return;
            }
            this.$axios.post(this.$kit.api.user.importSettleAccount, this.excelData)
                .then((result) => {
                    if(result.status){
                        // 后端已按行设置好了 msg（成功 / 已更新无需处理 / 各类错误），仅做兜底翻译
                        (result.data || []).forEach(r => {
                            try{
                                if(r.success && !r.msg){
                                    r.msg = this.msg("成功");
                                }
                            }catch(err){
                                console.error(err);
                            }
                        });
                        this.results = result.data || [];
                        // 显示后端返回的汇总信息（共 N 条，成功 M 条，失败 K 条）
                        if(result.msg){
                            if((result.data || []).some(r => !r.success)){
                                this.$message.warning(result.msg);
                            }else{
                                this.$message.success(result.msg);
                            }
                        }
                        // 通知父组件可以刷新列表
                        this.$emit("refresh");
                    }else{
                        this.$message.error(result.msg || this.msg('导入失败'));
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(this.msg('网络异常，导入失败'));
                });
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
